import { INTEGRATION_TYPES, type IntegrationDefinition } from '../types'

export const DEFAULT_CENTRAL_SQUARE_CONFIG = {}

export const centralSquareIntegration: IntegrationDefinition = {
  id: INTEGRATION_TYPES.CENTRAL_SQUARE,
  title: 'Central Square',
  defaultConnectionName: 'Central Square',
  logo: 'https://polimorphic-static.s3.us-east-2.amazonaws.com/3p-logos/centralsquare-logo.png',
  icon: 'https://polimorphic-static.s3.us-east-2.amazonaws.com/3p-logos/centralsquare-icon.png',
  cardDescription:
    'Connect to Central Square TRAKiT to create and retrieve permits via browser automation.',
  modalDescription:
    'Connect to Central Square TRAKiT permitting system. The integration uses browser automation to interact with the TRAKiT web UI for permit creation and retrieval.',
  formFields: [
    {
      name: 'host',
      label: 'TRAKiT URL',
      placeholder: 'e.g., pine-trk-tst.example.com',
      helperText: 'The TRAKiT server URL for your organization (without https://)',
      required: true,
      type: 'text',
    },
    {
      name: 'username',
      label: 'Username',
      placeholder: 'Enter your TRAKiT username',
      helperText: 'Your TRAKiT login username',
      required: true,
      type: 'text',
    },
    {
      name: 'password',
      label: 'Password',
      placeholder: 'Enter your TRAKiT password',
      helperText: 'Your password is stored securely and encrypted',
      required: true,
      type: 'password',
    },
  ],
  apiConfig: {
    createEndpoint: '/integrations/generate-central-square-integration/',
    buildPayload: (formData, config, _organizationId, organizationIdentityId) => {
      const host = formData.host.replace(/^https?:\/\//, '').replace(/\/+$/, '')
      return {
        organization_identity_id: organizationIdentityId,
        username: formData.username,
        password: formData.password,
        base_url: `https://${host}`,
        connection_name: formData.connectionName || 'Central Square',
        excluded_endpoints: (config.excluded_endpoints as string[]) || [],
      }
    },
    authTokenName: 'password',
    buildTestCredentials: (formData) => {
      const host = formData.host.replace(/^https?:\/\//, '').replace(/\/+$/, '')
      return {
        base_url: `https://${host}`,
        username: formData.username,
        password: formData.password,
      }
    },
  },
  defaultConfig: { ...DEFAULT_CENTRAL_SQUARE_CONFIG },
  endpoints: [
    {
      name: 'Create Permit',
      method: 'BROWSER',
      description: 'Create a new permit in TRAKiT via browser automation',
      toolName: 'create_permit',
    },
    {
      name: 'Get Permit',
      method: 'BROWSER',
      description: 'Retrieve permit details from TRAKiT via browser automation',
      toolName: 'get_permit',
    },
  ],
}
